module.exports = __webpack_public_path__ + "static/assets/b042d172da3763f5f2a58bd8cb80dae7.gif";